import axios from 'axios';
import moment from 'moment';
import { title } from 'process';
import React, { useRef, useState } from 'react'
import { toast } from 'react-toastify';
import { Toast } from 'react-toastify/dist/components';
import { FLASK_API, JAVA_DASHBOARD_API } from '../../../../../constants';
import { IRamedialReports, ISelectedFiltersUsingName, ITeacherReportsLable } from '../../../../../types';
import ReportFormatter from '../Formater/ReportFormater';
import { getStudentMonitoring } from '../ReportApi/TableRaportApi';
import { handleDownload } from '../../../../../utilityFunctions';
import { getDataRangeByWeekNo } from '../../../../../Services/utils';
import { useSelector } from 'react-redux';
import { State } from '../../../../../Reducers/types';

export function useTotalRamedialTest() {

    const { filter } = useSelector((state: State) => state);

    const [showFilterAlert, setShowFilterAlert] = useState<boolean>(false);
    const [selectedFilters, setSelectedFilters] =
        useState<ISelectedFiltersUsingName>();
    const [selectedFilterForReport, setSelectedFilterForReport] =
        useState<ISelectedFiltersUsingName>();
    const [reportData, setReportData] = useState<any>(null); // stores report data
    const [fileName, setFileName] = useState<string>(""); // stores the file name to be exported as csv

    // loading
    const [isDownloadingReport, setIsDownloadingReport] = useState<boolean>(false); // for download file loader
    const refDownloadFile = useRef<any>();
    const weeKForAPi = (moment().week() - 1)


    const extraLabel = {
        total_ramedial_test_attempted: "Total_remedial",
        total_pall_usage_in_min: "Total_usage_in_min",
        total_assignments_attempted: "Total_assignments_attempted",
        atleast_1_diagnostic_test: "Total_diagnostic_tests_attempted",
        usage_after_two: "Total_usage_after_two",
        usage_befor_two: "Total_usage_befor_two",
        spent_on_videos: "Total_spent_on_videos",
        total_time_spent_on_tests: "Total_time_spent_on_tests",
        total_queries_raised_per_student: "Total_queries_raised",
        total_queries_resolved_per_student: "Total_queries_solved",
        //Teacher ExtraLabel
        total_pall_usage_in_min_teacher: "Total_usage_in_min",
        total_assessments_by_teacher: "Total_assessments"
    }

    let eAdhighamReports = [{
        title: "e-Adhigam Teacher Data",
        description: "Teacher Weekly e-Adhigam Report",
        navigateTo: "teacher",
    },
        // {
        //     title: "e-Adhigam Student Data",
        //     description: "Student Weekly e-Adhigam Report",
        //     navigateTo: "student",
        // },
    ]

    let AllTeacherReports = [
        {
            title: "PAL Usage by Teachers (in mins)",
            description: "Total App Usage in min",
            navigateTo: "total_pall_usage_in_min_teacher",
        },
        {
            title: "PAL Homework Assigned by Teachers",
            description: "Total Homeworks / Assignments",
            navigateTo: "total_assessments_by_teacher",
        }
    ]

    let othersReports = [{
        title: "Time Spent by Teachers on Student Monitoring (in mins)",
        description: "Teachers Time Spent On Student Monitoring",
        navigateTo: "student_monitoring",
    }
    ]

    let AllReportsName = [{
        title: "Remedial tests Attempted by Students",
        description: "Total Remedial tests attempted by students",
        navigateTo: "total_ramedial_test_attempted",
    },
    {
        title: "PAL Usage by Students (in mins)",
        description: "Total App Usage in min",
        navigateTo: "total_pall_usage_in_min",
    },
    {
        title: "Homework Attempted by Students",
        description: "Homework Attempted by Students",
        navigateTo: "total_assignments_attempted",
    },
    {
        title: "Students who have attempted at least 1 diagnostic test",
        description: "Student attempted at least 1 Diagnostic test",
        navigateTo: "atleast_1_diagnostic_test",
    },
    // {
    //     title: "Pal usage after 2pm",
    //     description: "Total time spent on Pal after 2PM",
    //     navigateTo: "usage_after_two",
    // },
    // {
    //     title: "Pal usage before 2pm",
    //     description: "Total time spent on Pal before 2PM",
    //     navigateTo: "usage_befor_two",
    // },
    {
        title: "Time Spent by Students on Videos (in mins)",
        description: "Total time spent on videos",
        navigateTo: "spent_on_videos",
    },
    {
        title: "Time Spent by Students on Tests (in mins)",
        description: "Total time spent on tests",
        navigateTo: "total_time_spent_on_tests",
    }
    ]


    // Function Handler 
    const fetchRamedialTest = async (type: string, title: string, reportFor: "teacher" | "student" | "eadhigam" | "Detailede-AdhigamStudentData" | "studentMonitoring" | "subjectWiseWeeklyStudentReport") => {

        if (!selectedFilterForReport?.week_no) {
            var answer = window.confirm("Are you sure you want to download monthly data?");
            console.log(answer)
            if (!answer) {
                return;
            }
        };

        setIsDownloadingReport(true);
        try {
            if (reportFor == "student") {
                handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/student-detailed-data-download?type=${type}&year=${filter.year}&week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
            if (reportFor == "teacher") {
                handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/teacher-detailed-data-download?type=${type}&year=${filter.year}&week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
            if (reportFor == "eadhigam") {
                let resp = handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/report-download/student?type=${type}&year=${filter.year}&week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
            if (reportFor == "Detailede-AdhigamStudentData") {
                let resp = handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/weekly-student-adhigam-report?week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&year=${filter.year}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
            if (reportFor == "studentMonitoring") {
                let resp = handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/timeSpentOnStudentMonitoring?start_date=${getDataRangeByWeekNo(selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi)?.startDate}&end_date=${getDataRangeByWeekNo(selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi)?.endDate}&year=${filter.year}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
            if (reportFor == "subjectWiseWeeklyStudentReport") {
                let resp = handleDownload(
                    `${JAVA_DASHBOARD_API}dashboard/weekly-student-subject-wise-report?week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&year=${filter.year}&district=${selectedFilterForReport?.districtId ? selectedFilterForReport?.districtId : "-1"}&block=${selectedFilterForReport?.blockId ? selectedFilterForReport?.blockId : "-1"}&school=${selectedFilterForReport?.schoolId ? selectedFilterForReport?.schoolId : "-1"}`
                    , title
                ).finally(() => setIsDownloadingReport(false))
            }
        } catch (error) {
            console.log("Error for download report: ", error);
            setIsDownloadingReport(false)
            toast.error("Failed to download reports");
        };

    };

    const generateReport = (data, labels, file_name) => {
        setFileName(file_name);

        // form data to download CSV
        let listData = data;
        let header = labels;
        // console.log("Data: ", listData, " Header: ", header);
        setReportData((oldData) => ({
            ...oldData,
            data: listData,
            headers: header,
        }));
        setIsDownloadingReport(false);
        refDownloadFile?.current?.getElementsByTagName("a")[0]?.click();
    };


    // new implementation for downloading reports .csv()
    const fetchWeeklyStudentSubjectWiseReport = () => {

        setIsDownloadingReport(true);
        axios.get(`${JAVA_DASHBOARD_API}dashboard/weekly-student-subject-wise-report-array?week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&year=${filter.year}&district=${selectedFilterForReport.districtId ? selectedFilterForReport.districtId : "-1"}&block=${selectedFilterForReport.blockId ? selectedFilterForReport.blockId : "-1"}&school=${selectedFilterForReport.schoolId ? selectedFilterForReport.schoolId : "-1"}`).then(
            (response) => {

                // console.log("Response for subject wise data: ", response.data);

                let data = response.data?.length ? response.data : [];
                const keys = Object.keys(response.data?.[0] || {});
                let labels = keys.map(each => ({ label: each, key: each }))

                if (data.length && labels.length) {
                    generateReport(
                        data,
                        labels,
                        `Subject Wise Weekly Student Report${selectedFilterForReport?.districtId ? `_${selectedFilterForReport?.districtId}` : ""}${selectedFilterForReport?.blockId ? `_${selectedFilterForReport?.blockId}` : ""}_${moment().format("DD-MM-YYYY")}`
                    );
                } else {
                    toast.warn("No data found for this year and week number");
                };

            }, (error) => {
                console.log("Error for download report: ", error);
                toast.error("Failed to download reports");
            }
        ).finally(() => setIsDownloadingReport(false));

    };

    const fetchWeeklyStudentAdhigamReport = () => {

        setIsDownloadingReport(true);
        axios.get(`${JAVA_DASHBOARD_API}dashboard/weekly-student-adhigam-report-array?week_no=${selectedFilterForReport?.week_no ? selectedFilterForReport?.week_no : weeKForAPi}&year=${filter.year}&district=${selectedFilterForReport.districtId ? selectedFilterForReport.districtId : "-1"}&block=${selectedFilterForReport.blockId ? selectedFilterForReport.blockId : "-1"}&school=${selectedFilterForReport.schoolId ? selectedFilterForReport.schoolId : "-1"}`).then(
            (response) => {

                // console.log("Response for subject wise data: ", response.data);

                let data = response.data || [];
                const keys = Object.keys(response.data[0]);
                let labels = keys.map(each => ({ label: each, key: each }))

                if (data.length && labels.length) {
                    generateReport(
                        data,
                        labels,
                        `Detailed e-Adhigam Student Data${selectedFilterForReport?.districtId ? `_${selectedFilterForReport?.districtId}` : ""}${selectedFilterForReport?.blockId ? `_${selectedFilterForReport?.blockId}` : ""}_${moment().format("DD-MM-YYYY")}`
                    );
                };

            }, (error) => {
                console.log("Error for download report: ", error);
                toast.error("Failed to download reports");
            }
        ).finally(() => setIsDownloadingReport(false));

    };


    return (
        {
            isDownloadingReport,
            setIsDownloadingReport,
            fetchRamedialTest,
            selectedFilters,
            setSelectedFilters,
            showFilterAlert,
            setShowFilterAlert,
            selectedFilterForReport,
            setSelectedFilterForReport,
            reportData,
            setReportData,
            fileName,
            setFileName,
            refDownloadFile,
            AllReportsName,
            AllTeacherReports,
            eAdhighamReports,
            weeKForAPi,
            fetchWeeklyStudentSubjectWiseReport,
            fetchWeeklyStudentAdhigamReport
        }
    )
}
